.container {
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  max-height: 48rem;
  overflow-y: auto;
  min-height: 24rem;
}

.form {
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
}

.row {
  display: flex;
  gap: 1.2rem;
  align-items: flex-end;
}

.role-container {
  flex: 1 0 auto;
}

.input-container {
  flex: 0 1 55%;
}

.remove-button-container {
  & > button {
    background: var(--color-grayscale-tuna);
    color: var(--color-grayscale-light-slate);

    & svg {
      stroke: var(--color-grayscale-light-slate);
      height: 1.2rem;
      width: 1.2rem;
    }
  }
}

.add-new-member-button {
  all: unset;
  color: var(--color-primary-crayola);
  font-size: 1.4rem;
  font-weight: 400;
  width: auto;

  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
}

.server-error-message {
  display: flex;
  justify-content: start;
  margin-top: -3rem;
  margin-bottom: 2rem;
  max-width: 100%;

  & > div {
    max-width: 32rem;
  }
}
